<template>
  <!--    头部登录注册栏-->
  <div class="header-bar mini-width">
    <div class="width-240" v-if="left"></div>
    <div :class="['flex-b', left ? 'w-1200' : 'w-1400']">
      <div class="pc-title hit-cursor" v-if="logo" @click="goHome">
        <img class="logo" src="../../static/index/logo.png" />
        <span>化联网</span>
      </div>
      <div v-else></div>
      <div class="top-text">
        <div class="login-text" v-if="!left">
          <div v-if="!showUser">
            <span @click="goLogin">登录</span>
            |
            <span @click="goRegister">注册</span>
          </div>
          <div v-else>
            <span @click="goUserCenter">个人中心</span>
            |
            <span @click="goLogout">退出登录</span>
          </div>
        </div>
        <div class="login-text" @click="goHome" v-else>返回首页</div>
        <span class="letter-box" @click="goMail">

          <img src="../../static/index/letter.png" />
          站内信
          <div class="degree-box" v-if="isLgoin&&user_count.message_count">{{user_count.message_count.length>3?'···':user_count.message_count}}</div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeTop",
  props: {
    logo: {
      type: Boolean,
      default: true,
    },
    left: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showUser: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLgoin() {
      return this.$store.getters.isLogin;
    },
    user_count() {
      // 添加安全检查
      const count = this.$store.getters.user_count;
      return count && typeof count === 'object' ? count : {};
    },
  },
  watch: {
    isLgoin: {
      handler(val) {
        this.userInner(val);
      },
    },
  },
  created() {
    this.userInner(this.isLgoin);
  },
  methods: {
    userInner(val) {
      if (val) {
        this.showUser = true;
      } else {
        this.showUser = false;
      }
    },

    goUserCenter() {
      this.$router.push("/user/index");
    },
    goHome() {
      this.$router.push("/");
    },
    goMail() {
      if (this.showUser) {
        this.$router.push("/user/message/mail");
      } else {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
      }
    },
    goLogin() {
      this.$router.push("/login");
    },
    goLogout() {
      this.$utils.logout(this.$store, this.$router);
      this.showUser = false;

      this.$message.success({
        message: "退出成功",
        duration: 2000,
        offset: 200,
      });
    },
    goRegister() {
      this.$router.push("/register");
    },
  },
};
</script>

<style scoped lang="scss">
.degree-box {
  display: inline-block;
  height: 16px;
  width: 16px;
  overflow: hidden;
  background: #FF4D4F;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  line-height: 16px;
  box-sizing: border-box;
}

.header-bar {
  width: 100%;
  height: 40px;
  background: #373F5D;
  text-align: center;
  line-height: 62px;
  display: flex;

  .width-240 {
    width: 240px;
    height: 62px;
  }

  .pc-title {
    font-weight: 700;
    font-size: 16px;
    color: #ffffff;
    text-align: left;
    line-height: 40px;

    .logo {
      width: 25px;
      height: 25px;
      vertical-align: middle;
      margin-right: 4px;
    }
  }

  .top-text {
    display: flex;
    font-weight: 400;
    font-size: 14px;
    color: #94b0b0;
    cursor: pointer;
    line-height: 40px;

    .login-text {
      margin-right: 20px;
      color: #ffffff;
    }

    .letter-box {
      color: #ffffff;

      img {
        width: 20px;
        height: 14px;
        vertical-align: middle;
      }
    }
  }
}
</style>
